module.exports = __webpack_public_path__ + "img/gasbot-side-left.485698da.webp";